export const GET_FEE_PAYMENTS = 'fee-payments/GET_FEE_PAYMENTS'
export const ADD_FEE_PAYMENT = 'fee-payments/ADD_FEE_PAYMENT'
export const APPROVE_FEE_PAYMENT = 'fee-payment/APPROVE_FEE_PAYMENT'
export const REJECT_FEE_PAYMENT = 'fee-payment/REJECT_FEE_PAYMENT'
export const SUBMIT_FEE_PAYMENT = 'fee-payment/SUBMIT_FEE_PAYMENT'
export const DELETE_FEE_PAYMENT = 'fee-payment/DELETE_FEE_PAYMENT'
export const EDIT_FEE_PAYMENT = 'fee-payment/EDIT_FEE_PAYMENT'
export const START_LOADING_FEE_PAYMENTS = 'fee-payment/START_LOADING_FEE_PAYMENTS'
export const STOP_LOADING_FEE_PAYMENTS = 'fee-payment/STOP_LOADING_FEE_PAYMENTS'
